const WireframeMaterial = () => <meshBasicMaterial color="black" wireframe />;

export default WireframeMaterial;
